import { render, staticRenderFns } from "./BankTransferFilesView.vue?vue&type=template&id=633d7745&scoped=true&"
import script from "./BankTransferFilesView.vue?vue&type=script&lang=js&"
export * from "./BankTransferFilesView.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferFilesView.vue?vue&type=style&index=0&id=633d7745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d7745",
  null
  
)

export default component.exports